import type {IProxiedHttpResponse} from '../../data-layer-client/FrameMessenger';

import type {Filter} from './types';
import {authStore} from '../authentication/AuthenticationStore';

export const authenticatedUserFilter: Filter = {
  matchers: [
    {
      urlPath: /\/v1\/connect\/user/,
      method: 'GET',
    },
  ],

  filterResponse: (
    response: IProxiedHttpResponse,
    authStateChangedCallback: () => void,
  ) => {
    let body;
    if (response.body && typeof response.body === 'string') {
      try {
        body = JSON.parse(response.body);
      } catch (e) {}
    }

    if (body && 'is_primary_user' in body) {
      authStore.setUser(body);
      authStateChangedCallback();
    }
    return response;
  },
};
